export const setGeneralSetting = "SET_GENERAL_SETTING";

export const toggleSidebarStatus = "TOGGLE_SIDEBAR_STATUS";
export const togglePaginationStatus = "TOGGLE_PAGINATION_STATUS";

export const updateLoginCodeStatus = "UPDATE_LOGIN_CODE_STATUS";
export const updateLoginCodeMessage = "UPDATE_LOGIN_CODE_MESSAGE";

export const updateEmmitSharedMediaDataListStatus = "UPDATE_EMIT_STATUS";
export const updateMediaPackageContainerSharedMediaTokens =
  "UPDATE_CONTAINER_TOKENS_LIST";
